import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import UserAPI from '../../Lib/Api/user';
import Role from '../../Lib/Constants/roles.ts';

// TODO: investigate if values are updated when window is resized
const useStyles = makeStyles()((theme) => ({
  root: {
    background: get(theme, 'palette.bg.main'),
    position: 'fixed',
    height: `${window.innerHeight}px`,
    left: 0,
    top: 0,
    width: `${window.innerWidth}px`,
    zIndex: '9999',
    overflow: 'hidden',
  },
  actions: {
    height: '100px',
    padding: '0px 24px',
  },
  embed: {
    flex: '1',
    height: `${window.innerHeight - 100}px`,
  },
}));

export default function VendorAgreementWall(props) {
  const { classes } = useStyles();
  const [link, setLink] = useState(null);
  const isVendorAdmin = get(props.user, 'role') === Role.VENDOR;

  function handleMsg(e) {
    if (!e || !e.data) return;

    let message = null;
    try {
      message = JSON.parse(e.data);
    } catch (err) {
      return;
    }

    if (
      message &&
      get(message, 'event') === 'session_view.document.completed'
    ) {
      setTimeout(() => props.getVendor(props.user.id), 1500);
    }
  }

  useEffect(() => {
    if (isVendorAdmin) {
      UserAPI.createDocumentLink(props.user.id, props.document.id)
        .then((response) => {
          setLink(response.link.id);
        })
        .catch(console.log);
    }
  }, [props.user.id, props.document.id, isVendorAdmin]);

  useEffect(() => {
    if (isVendorAdmin) {
      window.addEventListener('message', handleMsg);
      return () => window.removeEventListener('message', handleMsg);
    }
    return undefined;
  }, [handleMsg, isVendorAdmin]);

  return (
    <Grid container classes={{ root: classes.root }} direction="column">
      <Grid
        container
        classes={{
          root: isVendorAdmin ? classes.embed : '',
        }}
        className={
          !isVendorAdmin
            ? 'flex-1 flex items-center justify-center text-center text-lg'
            : ''
        }
      >
        {isVendorAdmin ? (
          link && (
            <iframe
              title="Vendor Agreement Embed"
              src={`https://app.pandadoc.com/s/${link}`}
              width={window.innerWidth}
              height={window.innerHeight - 100}
            />
          )
        ) : (
          <div className="mx-auto max-w-5xl">
            <h2>Vendor Agreement Pending</h2>
            <p>
              A Vendor Agreement is currently pending signature by your Vendor
              Portal Administrator. You will not be able to access the Vendor
              Portal until the agreement has been signed.
            </p>
            <p>
              Please contact your Vendor Portal Administrator to complete the
              agreement signing process. If you have any questions or concerns,
              please contact{' '}
              <a href="mailto:vendorsupport@fashionnova.com">
                vendorsupport@fashionnova.com
              </a>
            </p>
          </div>
        )}
      </Grid>
      <Grid container classes={{ root: classes.actions }} alignItems="center">
        <Grid item xs={6}>
          <Grid container justifyContent="flex-start" alignItems="center">
            {isVendorAdmin && (
              <>
                You must sign the above vendor agreement before you are able to
                continue using the Vendor Portal. If you have any questions or
                concerns please contact{' '}
                <a href="mailto:vendorsupport@fashionnova.com">
                  vendorsupport@fashionnova.com
                </a>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container justifyContent="flex-end" alignItems="center">
            <Button color="primary" variant="contained" onClick={props.logout}>
              Logout
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

VendorAgreementWall.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.number,
    pandadoc_id: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
    role: PropTypes.string,
  }).isRequired,
  getVendor: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};
